<div mat-dialog-content> <!-- [perfectScrollbar]="{wheelPropagation: false, suppressScrollX: true}"-->
    <div  
        [ngStyle]="{'max-height': '40vh', 'position': 'relative'}"        
        class="kt-margin-t-10 kt-margin-b-10">
        <div class="file-container" [innerHtml] = "innerFile"></div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary"  class="btn-return" cdkFocusInitial (click)="dialogRef.close(false)">
        {{'AUTH.DIALOG.INFORMATION.BUTTON.CANCEL' | translate}}
    </button>
</div>
<!-- LOADER -->
<!-- <div *ngIf="pageLoading$ | async" style="max-height: 30px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);">
    <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate"></mat-progress-spinner>
</div> -->
<!-- LOADER -->